export const DATE_FORMAT_UI = 'MM/DD/YYYY'

export const DATE_TIME_FORMAT_UI = 'MM/DD/YYYY HH:mm:SS'

export const DATE_HOUR_FORMAT_UI = 'MM/DD/YYYY HH'

export const DATE_HOUR_MIN_FORMAT_UI = 'MM/DD/YYYY HH:mm'

export const DATE_FORMAT_API = 'YYYY-MM-DD'

export const DATE_TIME_FORMAT_API = 'YYYY-MM-DDTHH:mm:ss'

export const GRID_DATA_DATETIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:SS.sssZZ'

export const GRID_DISPLAY_DATETIME_FORMAT = DATE_TIME_FORMAT_UI

export const modalZIndex = 1020
